import styled from 'styled-components'

export const FiltersContainer = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 10px auto 0;
`
